module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//gorilla_6_1.png?v=5a6b15d7";